<template>
  <div v-if="screenWidth >= 768" class="small-favourite">
    <div class="small-favourite__icon" @click="handlerOpenFavourite">
      <svg><use xlink:href="#svg-favourite"></use></svg>
      <span v-if="likes && likes.length" class="small-favourite__count">
        {{ likes.length }}
      </span>
    </div>
    <DefEmpty v-if="isOpenMessage && !likes?.length" @close="isOpenMessage = false">
      <span>{{ messages.emptyWishlist }}</span>
    </DefEmpty>
  </div>
</template>

<script setup lang="ts">
import DefEmpty from '@components/Def/DefEmpty/DefEmpty.vue';
import useScreenWidth from '@use/useScreenWidth';
import useFavouriteModal from '@use/useFavouriteModal';
import { useFavouriteStore } from '@/storePinia/stores/favourite';

import { ref } from 'vue';
import { storeToRefs } from 'pinia';

const screenWidth = useScreenWidth();

const isOpenMessage = ref(false);
const favouriteModal = useFavouriteModal();
const favouriteState = useFavouriteStore();

const { messages, likes } = storeToRefs(favouriteState);

const handlerOpenFavourite = () => {
  if (likes.value?.length) {
    favouriteModal.open();
  } else {
    isOpenMessage.value = true;
  }
};
</script>

<style lang="scss" scoped>
.small-favourite {
  &__icon {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    svg {
      display: block;
      width: 24px;
      height: 24px;
      transition: 0.2s linear fill, 0.2s linear transform;
    }
    &:hover {
      svg {
        fill: var(--color-link-hover-dark);
        transform: scale(1.1);
      }
    }
  }
  &__count {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 16px;
    height: 16px;
    background-color: var(--color-main);
    border-radius: 50%;
    position: absolute;
    top: -8px;
    right: -8px;
    color: #fff;
    font-weight: 500;
    font-size: rem(12);
  }
}
</style>
